import {
  faCheckCircle,
  faExclamationSquare,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';

import PantheorIcon from './PantheorIcon';

const iconColor = {
  danger: 'text-red-3',
  info: 'text-blue-3',
  pantheor: 'text-purple-3',
  success: 'text-green-3',
  warning: 'text-orange-3',
  working: 'text-current',
};

const alertIcon = {
  danger: faExclamationSquare,
  info: faInfoCircle,
  working: faSpinnerThird,
  success: faCheckCircle,
  warning: faExclamationTriangle,
};

const NotificationStatusIcon = ({ alt, type, ...rest }) => (
  <span className={`${iconColor[type]} inline mr-2`}>
    {type === 'pantheor' ? (
      <PantheorIcon aria-label={alt} role="img" {...rest} />
    ) : (
      <Icon
        alt={alt}
        icon={alertIcon[type]}
        spin={type === 'working'}
        {...rest}
      />
    )}
  </span>
);

NotificationStatusIcon.defaultProps = {
  alt: '',
};

NotificationStatusIcon.propTypes = {
  alt: PropTypes.string,
  type: PropTypes.oneOf([
    'danger',
    'info',
    'pantheor',
    'success',
    'warning',
    'working',
  ]).isRequired,
};

export default NotificationStatusIcon;
